// @flow
import React from 'react';
import { Collapse } from 'reactstrap';

import type { Node } from 'react';

import Toggler from '../../../../components/UI/Toggler';

type Props = {
  children: Node,
  title: string,
  cost?: number,
  isPaid?: boolean,
  openCollapse: boolean,
  extraClassName: string,
};

const CollapseContainer = ({
  title,
  cost,
  children,
  openCollapse = true,
  extraClassName = '',
}: Props) => (
  <Toggler initialOn={openCollapse}>
    {({ on, toggle }) => (
      <div className={`breakdown ${extraClassName}`}>
        <h3 onClick={toggle} className="brekdown-title">
          <span>{title}</span>
          <span className="brekdown-price" style={{ cursor: 'pointer' }}>
            {cost && <span>USD {Number(cost).toLocaleString()} </span>}
            <i className={`icon icon-hg-chev-${on ? 'up' : 'down'}`} />
          </span>
        </h3>
        <Collapse isOpen={on}>{children}</Collapse>
      </div>
    )}
  </Toggler>
);

export default CollapseContainer;



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/CollapseContainer.js